import axios from "axios";

import { BASE_URL, CLIENT_SECRET, CLIENT_ID } from '../constants/constants';

const api = axios.create({
  baseURL: BASE_URL,
  // timeout: 3600,
  headers: {
    Accept: "application/json",
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'X-Content-Type-Options': "nosniff",
    "X-XSS-Protection": "1; mode=block"
  }
});

// Auth Services

export function auth_user(data) {

  const userCredentials = {
    "grant_type": "password",
    "client_id": CLIENT_ID,
    "client_secret": CLIENT_SECRET,
    "username": data.username,
    "password": data.password
  }
  const response = api.post("api/login", userCredentials);
  return response.then((data) => data).catch((error) => error);
}


export function logout_user(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.post("api/logout", {}, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getUserInfo(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/user-detail", { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// Institutions Categories services

export function getInstitutionCategories(token, page, searchText) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/categoryInstitution?page=${page}&category=${searchText}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getInstitutionCategory(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/categoryInstitution/" + id.id_institution_category, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function addInstitutionCategory(data, token) {
  const formData = new FormData();
  const header = {
    Authorization: "Bearer " + token,
  };
  formData.append("libelle", data);
  const response = api.post("api/categoryInstitution", formData, { headers: header });


  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}

export function updateInstitutionCategory(id, data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };

  const request = {
    "libelle": data
  };

  const formData = new FormData();

  formData.append("libelle", data);
  formData.append("_method", "put");
  console.log("request", request);
  const response = api.post("api/categoryInstitution/" + id.id_institution_category, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteCategoryInstitution(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/categoryInstitution/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function uploadCategoriesInstitutionFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("file", data);
  const response = api.post("api/import-categoryInstitution", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// Agent Services

export function getAgents(token, page, searchText) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/agent?page=${page}&name=${searchText}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getAgent(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id Agent ", id.id_agent)
  const response = api.get("api/agent/" + id.id_agent + "/edit", { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function addAgent(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log(data)

  const formData = new FormData();
  // formData.append("nom", data.nom);
  // formData.append("prenom", data.prenom);
  // formData.append("telephone", data.telephone);
  // formData.append("sexe", data.sexe.id);
  // formData.append("type_agent", data.type.id);
  // formData.append("poste", data.poste);
  // formData.append("email", data.email);
  // formData.append("institution_id", data.institution.id);
  // formData.append("password", data.password);
  // formData.append("role", data.roles)
  // console.log("role Agent : ", data.roles)
  // console.log(formData)

  const roleReformat = (data.roles === undefined || data.roles === []) ? "" : data.roles;

  const dataToSend = {
    "nom": data.nom,
    "prenom": data.prenom,
    "telephone": data.telephone,
    "sexe": data.sexe.value,
    "type_agent": data.type.value,
    "poste": data.poste,
    "institution_id": data.institution.value,
    "email": data.email,
    "password": data.password,
    "role": roleReformat,
    "isBcc": data.isBCC.value
  }

  const response = api.post("api/agent", dataToSend, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function updateAgent(id, data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const roleReformat = (data.roles === undefined || data.roles === []) ? "" : data.roles;

  const dataToSend = {
    "nom": data.nom,
    "prenom": data.prenom,
    "telephone": data.telephone,
    "sexe": data.sexe.value,
    "type_agent": data.type.value,
    "poste": data.poste,
    "institution_id": data.institution.value,
    "email": data.email,
    // "password" : data.password,
    "role": roleReformat,
    "isBcc": data.isBCC.value
  }
  const formData = new FormData();
  console.log("role Agent : ", dataToSend)
  formData.append("_method", "put");
  const response = api.put("api/agent/" + id.id_agent, dataToSend, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteAgent(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/agent/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getInstitutionsOfCategory(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id)
  const response = api.get("api/listOfInstitution/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function uploadAgentFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("file", data);
  const response = api.post("api/import-agent", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function lockAgent(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id)
  const response = api.post("api/lock-user/" + id, {}, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function unlockAgent(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id)
  const response = api.post("api/unlock-user/" + id, {}, { headers: header });
  return response.then((data) => data).catch((error) => error);
}




// Product Http Services

export function getProducts(token, page, searchText) {
  console.log("token is ---- ", token)
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/product?page=${page}&product=${searchText}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getProductsCategoriesCreated(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/product/create", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getProduct(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id)
  const response = api.get("api/product/" + id.id_product, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function editProduct(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id)
  const response = api.get("api/product/" + id.id_product + "/edit", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function addProduct(data, token, instit_id) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log(data)
  const formData = new FormData();
  formData.append("libelle", data.libelle);
  formData.append("categoryproduct_id", data.category.value);

  // if (data.institution.value !== '') {
  //   formData.append("institution", data.institution.value);
  // }
  if (instit_id != "") {
    formData.append("institution", instit_id);
  } else {
    formData.append("institution", data.institution.value);
  }

  const response = api.post("api/product", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function updateProduct(id, data, token, instit_id) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log(data)
  const formData = new FormData();
  formData.append("libelle", data.libelle);
  formData.append("categoryproduct_id", data.category.value);
  // if (data.institution.value !== '') {
  //   formData.append("institution", data.institution.value);
  // }
  if (instit_id != "") {
    formData.append("institution", instit_id);
  } else {
    formData.append("institution", data.institution.value);
  }
  formData.append("_method", "put");
  const response = api.post("api/product/" + id.id_product, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteProduct(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/product/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function uploadProductFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("file", data);
  const response = api.post("api/import-product", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getInstitutionsWithoutBCC(token) {
  console.log("token is ---- ", token)
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/institutionListSecond", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

// Institution Http  Services


export function getInstitutions(token, page, searchText) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/institution?page=${page}&institution=${searchText}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getInstitutionsCategoriesCreated(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/institution/create", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getInstitution(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id.id_institution)
  const response = api.get("api/institution/" + id.id_institution + "/edit", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function addInstitution(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log(data)
  var zoneArray = [];
  let zoneString;
  let zoneToSend = [];
  const zoneReformat = (data.zones === undefined || data.zones === []) ? [] : data.zones;
  if (zoneReformat !== []) { zoneReformat.map(item => zoneArray.push(item.value)) }
  if (zoneReformat !== []) { zoneString = zoneArray.join() }
  console.log("Zone String ", zoneString)
  zoneToSend.push(zoneString)
  console.log("Zone Array ", zoneArray)

  const formData = new FormData();
  formData.set("libelle", data.libelle);
  formData.set("email", data.email);
  formData.set("telephone", data.telephone);
  formData.set("categoryinstitution_id", data.category.value);
  if (zoneArray?.length !== 0) {
    for (let i = 0; i < (zoneArray).length; i++)
      formData.append("zone[]", zoneArray[i]);
  } else {
    formData.append("zone", zoneArray);
  }
  // formData.set("zone", zoneToSend);
  formData.append("file", data.logo);
  // const dataToSend = {
  //   "libelle":data.libelle,
  //   "email":data.email,
  //   "telephone":data.telephone,
  //   "categoryinstitution_id":data.category.value,
  //   "zone": zoneArray
  // }
  const response = api.post("api/institution", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function updateInstitution(id, data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log(data)
  var zoneArray = [];
  let zoneString;
  const zoneReformat = (data.zones === undefined || data.zones === []) ? "" : data.zones;
  if (zoneReformat !== []) { zoneReformat.map(item => zoneArray.push(item.value)) }
  if (zoneReformat !== []) { zoneString = zoneArray.join() }
  const formData = new FormData();
  formData.append("libelle", data.libelle);
  formData.append("categoryinstitution_id", data.category.value);
  formData.append("email", data.email);
  formData.append("telephone", data.telephone);
  if (zoneArray?.length !== 0) {
    for (let i = 0; i < (zoneArray).length; i++)
      formData.append("zone[]", zoneArray[i]);
  } else {
    formData.append("zone", zoneArray);
  }
  // console.log("logo ", data.logo.includes("png"))
  // if(data.logo?.includes("png") || data.logo?.includes("jpg") || data.logo?.includes("jpeg")) {
  console.log("first")
  // formData.append("file", null);
  // } else {
  formData.append("file", data.logo);
  console.log("second")

  // }
  formData.append("_method", "put");
  // const dataToSend = {
  //   "libelle":data.libelle,
  //   "email":data.email,
  //   "telephone":data.telephone,
  //   "categoryinstitution_id":data.category.value,
  //   "zone": zoneArray
  // }
  const response = api.post("api/institution/" + id.id_institution, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteInstitution(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/institution/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function uploadInstitutionFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("file", data);
  const response = api.post("api/import-institution", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}



// Product Category Services

export function getProductCategories(token, page, searchText) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/categoryProduct?page=${page}&category=${searchText}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getProductCategory(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id ", id.id_product_category)
  const response = api.get("api/categoryProduct/" + id.id_product_category, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function addProductCategory(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();

  formData.append("libelle", data);
  const response = api.post("api/categoryProduct", formData, { headers: header });


  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}

export function updateProductCategory(id, data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const request = {
    "libelle": data
  };
  console.log(id)

  const formData = new FormData();

  formData.append("libelle", data);
  formData.append("_method", "put");
  console.log("request", request);
  const response = api.post("api/categoryProduct/" + id.id_product_category, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteProductCategory(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/categoryProduct/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function uploadProductCategoryFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("file", data);
  const response = api.post("api/categoryProduct", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}


// Roles Services 


export function getRoles(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/roles", { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getRole(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("id Role ", id.id_role)
  const response = api.get("api/roles/" + id.id_role + "/edit", { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function addRole(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log(data)

  const response = api.post("api/roles", data, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function updateRole(id, data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("permission", data.permissions);
  formData.append("_method", "put");
  const response = api.put("api/roles/" + id.id_role, data, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteRole(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/roles/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getPermissionsOfCategory(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/roles/create", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

// Transmission Services 


export function getInstitutionsProducts(token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/institution-product", { headers: header });
  return response.then((data) => data).catch((error) => error);
}
export function viewTauxProducts(idTransmission, token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/view-listTauxProduct/" + idTransmission.id_transmission, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function addTaux(data, token) {


  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.post("api/transmission", data, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getTaux(token, year, page) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/list-transmission/" + year + `?page=${page}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getTransmissionsYears(token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/year-transmission", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getLastTransmissionDate(token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/lastDate-transmission", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function uploadTauxFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("mois", data.mois);
  formData.append("annee", data.annee);
  // formData.append("statut", data.statut);
  formData.append("file", data.file);
  const response = api.post("api/import-taux", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}



// Doownload Files Services


export const downloadInstitutionFile = (token) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-InstitutionFile", { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

export const downloadCategoryInstitutionFile = (token) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-CategoryInstitutionFile", { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

export const downloadProductFile = (token) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-ProductFile", { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

export const downloadAgentFile = (token) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-AgentFile", { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

export const downloadTauxFile = (token) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-TauxFile", { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

export const downloadZoneFile = (token) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-ZoneFile", { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

// Configurationn Services

export function addConfiguration(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };

  const dataFormatted = {
    "server_mail": [{
      "server": data.server,
      "port": data.port,
      "email": data.email,
      "password": data.password
    }],
    "calendar": [{
      "day_before_end": data.numberOfDaysGivenBeforeTransmission,
      "day_after_end": data.numberofDaysBeforeDueDate,
      "taux_maximal": data.maxRate

    }],
    "sms": [{
      "send_by_sms": data.smsNotif == false ? "0" : "1",
      "code_iso": data.isoCode

    }],
    "notification": [{
      "message_dsif_normal": data.notifMsgNormal,
      "message_rappel_avant": data.notifMsgReminderBefore,
      "message_rappel_jj": data.notifMsgReminderPresent,
      "message_depassement_echeance": data.notifMsgReminderAfter,
      "message_dsif_grace": data.notifMsgGrace
    }]
  }
  const response = api.post("api/configuration", dataFormatted, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getConfiguration(token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/configuration", { headers: header });
  return response.then((data) => data).catch((error) => error);
}



// Suivi Taux Services

export function getSuiviTauxParams(token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/suivi-taux", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getSuiviTauxInstitutionsFromCategoryAndZone(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  var zone = data.zone ? data.zone : "";
  var category = data.category ? data.category : "";
  formData.append("zone", zone);

  formData.append("category", category);


  const response = api.post(`api/InstitutionsFromcategoryAndzone`, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}


export function getSuiviTauxList(data, token, freshly, page) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  if (freshly === false) {
    console.log(data)
    if (data.mois !== '') {
      var theMonth = parseInt(data.mois) < 10 ? "0" + parseInt(data.mois) : "" + parseInt(data.mois)
      formData.append("mois", theMonth);
    }
    if (data.category_institution !== '') {
      formData.append("category_institution", data.category_institution);
    }
    if (data.institution !== '') {
      formData.append("institution", data.institution);
    }
    if (data.zone !== '') {
      formData.append("zone", data.zone);
    }
    if (data.annee !== '') { formData.append("annee", data.annee); }
  }
  if (data.category_product !== '') {
    formData.append("category_product", data.category_product);
  }

  for (var value of formData.values()) {
    console.log(value);
  }
  const response = api.post(`api/suivi-taux?page=${page}`, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}



export function getSuiviTauxCategoriesRates(data, token, freshly) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  if (freshly === false) {
    console.log(data)
    if (data.mois !== '') {
      var theMonth = parseInt(data.mois) < 10 ? "0" + parseInt(data.mois) : "" + parseInt(data.mois)
      formData.append("mois", theMonth);
    }
    if (data.category_institution !== '') {
      formData.append("category_institution", data.category_institution);
    }
    if (data.institution !== '') {
      formData.append("institution", data.institution);
    }
    if (data.zone !== '') {
      formData.append("zone", data.zone);
    }
    if (data.annee !== '') { formData.append("annee", data.annee); }

    if (data.category_product !== '') {
      formData.append("category_product", data.category_product);
    }
  }
  for (var value of formData.values()) {
    console.log(value);
  }
  const response = api.post(`api/categoriesRate`, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}



// Suivi Transmission Services

export function getSuiviTransmissionParams(token) {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/suivi-transmission", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getSuiviTransmissionList(data, token, page) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  if (data.institution != undefined) { formData.append("institution", data.institution); }
  if (data.statut != undefined) { formData.append("statut", data.statut); }
  if (data.debut != undefined) { formData.append("debut", data.debut); }
  if (data.fin != undefined) { formData.append("fin", data.fin); }
  const response = api.post(`api/suivi-transmission?page=${page}`, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}

export function getSuiviTransmissionDetails(token, id) {
  const header = {
    Authorization: "Bearer " + token,
  };

  const response = api.get("api/detail-suiviTransmission/" + id.id_suivi_transmission, { headers: header });
  return response.then((data) => data).catch((error) => error);

}


// Institutions Categories services

export function getZones(token, page, searchText) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/zone?page=${page}&zone=${searchText}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getZone(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/zone/" + id.id_zone + "/edit", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function addZone(data, token) {
  const formData = new FormData();
  const header = {
    Authorization: "Bearer " + token,
  };
  formData.append("libelle", data);
  const response = api.post("api/zone", formData, { headers: header });


  return response.then((data) => data).catch((error) => error);
  // console.log("error ", error.response.data)
}

export function updateZone(id, data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };

  const request = {
    "libelle": data
  };

  const formData = new FormData();

  formData.append("libelle", data);
  formData.append("_method", "put");
  console.log("request", request);
  const response = api.post("api/zone/" + id.id_zone, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function deleteZone(id, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.delete("api/zone/" + id, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function uploadZoneFile(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  formData.append("file", data);
  console.log(data)

  const response = api.post("api/import-zone", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// Journal Service 

export function getLogsAndParams(token, page) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/journal?page=${page}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getLogs(token, data, page) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();

  console.log(data)
  if (data.debut !== '') {
    formData.append("debut", data.debut);
  }
  if (data.institution !== '') {
    formData.append("institution", data.institution);
  }
  if (data.fin !== '') {
    formData.append("fin", data.fin);
  }

  if (data.user !== '') {
    formData.append("user", data.user);
  }
  if (data.action !== '') {
    formData.append("action", data.action);
  }

  for (var value of formData.values()) {
    console.log(value);
  }
  const response = api.post(`api/journal?page=${page}`, formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// Dashboard Services

export function getFiltersInstitution(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/chart", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getFiltersStaff(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/chartStaff", { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getAvgRateByCategoryBcc(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();

  console.log(data)
  if (data.debut !== '') {
    formData.append("debut", data.debut);
  }
  if (data.institution !== '') {
    formData.append("institution", data.institution);
  }
  if (data.institutionCategory !== '') {
    formData.append("category_institution", data.institutionCategory);
  }
  if (data.fin !== '') {
    formData.append("fin", data.fin);
  }

  if (data.zone !== '') {
    formData.append("zone", data.zone);
  }


  // for (var value of formData.values()) {
  //   console.log(value);
  // }
  const response = api.post("api/chartStaff-month", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getAvgRateByCategoryInstitution(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };

  const formData = new FormData();
  console.log(data)
  if (data.debut !== '') {
    formData.append("debut", data.debut);
  }
  if (data.fin !== '') {
    formData.append("fin", data.fin);
  }
  const response = api.post("api/chart-month", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getRateByProductStaff(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();

  console.log(data)
  if (data.debut !== '') {
    formData.append("debut", data.debut);
  }
  if (data.institution !== '') {
    formData.append("institution", data.institution);
  }
  if (data.produit !== '') {
    formData.append("product", data.produit);
  }
  if (data.institutionCategory !== '') {
    formData.append("category_institution", data.institutionCategory);
  }
  if (data.fin !== '') {
    formData.append("fin", data.fin);
  }

  // if(data.zone !== '') {
  //   formData.append("zone", data.zone);
  // }
  const response = api.post("api/chartStaff-product", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getRateByProductInstitution(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();

  console.log(data)
  if (data.debut !== '') {
    formData.append("debut", data.debut);
  }
  if (data.produit !== '') {
    formData.append("product", data.produit);
  }
  if (data.fin !== '') {
    formData.append("fin", data.fin);
  }

  // if(data.zone !== '') {
  //   formData.append("zone", data.zone);
  // }
  const response = api.post("api/chart-product", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getComparision(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };


  const dataToSend = {
    "institutions": data.institution,
    "category_product": data.productCategory,
    "debut": data.debut,
    "fin": data.fin
  }

  // if(data.zone !== '') {
  //   formData.append("zone", data.zone);
  // }
  const response = api.post("api/comparaison", dataToSend, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getListInstitutionsFromCategory(token, idCategory) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/list-Institutions/" + idCategory, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getListInstitutionsFromZone(token, idZone) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/list-Institutions-zone/" + idZone, { headers: header });
  return response.then((data) => data).catch((error) => error);
}
export function getListInstitutionsFromCategoryAndZone(token, idZone, idCategory) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/list-Institutions-categoryzone/" + idZone + "/" + idCategory, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// Transmission Comments Service

export function addComment(token, data, type) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();
  let dataToSend;
  formData.append("transmission", data.transmission.id_transmission);
  if (type === "text") {
    console.log("Type text")
    formData.append("commentaire", data.commentaire.message);
    formData.append("file", "");

  } else {
    console.log("Type file")
    console.log("File ", data.commentaire?.file)
    if (data.commentaire?.file?.length !== 0) {
      for (let i = 0; i < (data.commentaire?.file).length; i++)
        formData.append("file[]", data.commentaire.file[i]);
    } else {
      formData.append("file", data.commentaire.file);
    }
    // formData.append("file", data.commentaire);
    formData.append("commentaire", data.commentaire.message);

    //   dataToSend =  {
    //     "transmission": data.transmission.id_transmission,
    //     "file": data.commentaire,
    // } 
  }

  const response = api.post("api/comments", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export const downloadCommentFile = (token, idComment) => {

  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/download-commentFile/" + idComment, { responseType: 'blob', headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getTransmissionComments(token, idTransmission) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/comments/" + idTransmission.id_transmission, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getNotifications(token, page) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/alerts?page=${page}`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getTotalUnreadNotifs(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get(`api/countCurrentUserAlert`, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function changeNotificationStatus(token, id, type) {
  const header = {
    Authorization: "Bearer " + token,
  };
  let response, response2;
  if (type === "comment") {
    response = api.get("api/comments-status/" + id, { headers: header });
    response2 = api.get("api/alerts/" + id, { headers: header });
  }
  if (type === "alert") {
    response = api.get("api/alerts-status/" + id, { headers: header });
  }
  return response2.then((data) => data).catch((error) => error);
}

// Webgate Services 

export function addPresentation(data, token) {
  const header = {
    Authorization: "Bearer " + token,
  };

  const dataToSend = {
    "description": data
  }
  const response = api.post("api/CreateOrUpdateAbout", dataToSend, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


export function getPresentation(token) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const response = api.get("api/genesis", { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// UserInfo

export function updateUserInfo(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("userData ", data)
  const formData = new FormData();
  formData.append("nom", data.nom);
  formData.append("prenom", data.prenom);
  formData.append("telephone", data.telephone);
  formData.append("email", data.email);
  formData.append("sexe", data.sexe.value);
  const response = api.post("api/update-UserPersonalInformation", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function updateUserPassword(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  const formData = new FormData();

  formData.append("oldpassword", data.old);
  formData.append("newpassword", data.new);
  formData.append("confirmpassword", data.confirmed);


  const response = api.post("api/update-UserPassword", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}


// Apps Configuration

export function updateAppsConfig(token, data) {
  const header = {
    Authorization: "Bearer " + token,
  };
  console.log("configData ", data)
  const formData = new FormData();
  // if (data.web.image !== "") {
    formData.append("background_image", data.web.image);
  // }
  // if (data.web.favicon !== "") {
    formData.append("application_favicon", data.web.favicon);
  // }
  // if (data.portal.image !== "") {
    formData.append("image", data.portal.image);
  // }
  // if (data.portal.favicon !== "") {
    formData.append("portail_favicon", data.portal.favicon);
  // }
  formData.append("application_name", data.web.name);
  formData.append("portail_application_name", data.portal.name);
  formData.append("primary", data.general.color.primary);
  formData.append("secondary", data.general.color.secondary);
  formData.append("tertiary", data.general.color.tertiary);
  const response = api.post("api/application_configuration", formData, { headers: header });
  return response.then((data) => data).catch((error) => error);
}

export function getAppsConfig() {
  const response = axios.get(`${BASE_URL}api/get-applicationConfiguration`);
  return response.then((data) => data).catch((error) => error);
}